var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntellectual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.47 8.682C12.35 8.094 12.098 7.638 11.714 7.314C11.33 6.99 10.814 6.828 10.166 6.828C9.614 6.828 9.152 6.93 8.78 7.134C8.408 7.338 8.108 7.608 7.88 7.944C7.664 8.28 7.508 8.67 7.412 9.114C7.316 9.546 7.268 9.996 7.268 10.464C7.268 10.896 7.316 11.316 7.412 11.724C7.52 12.132 7.682 12.498 7.898 12.822C8.114 13.134 8.396 13.386 8.744 13.578C9.092 13.77 9.506 13.866 9.986 13.866C10.742 13.866 11.33 13.668 11.75 13.272C12.182 12.876 12.446 12.318 12.542 11.598H14.108C13.94 12.75 13.508 13.638 12.812 14.262C12.128 14.886 11.192 15.198 10.004 15.198C9.296 15.198 8.666 15.084 8.114 14.856C7.574 14.628 7.118 14.304 6.746 13.884C6.386 13.464 6.11 12.966 5.918 12.39C5.738 11.802 5.648 11.16 5.648 10.464C5.648 9.768 5.738 9.12 5.918 8.52C6.098 7.908 6.368 7.38 6.728 6.936C7.1 6.48 7.562 6.126 8.114 5.874C8.666 5.61 9.308 5.478 10.04 5.478C10.568 5.478 11.06 5.544 11.516 5.676C11.984 5.796 12.392 5.988 12.74 6.252C13.1 6.516 13.394 6.852 13.622 7.26C13.85 7.656 13.994 8.13 14.054 8.682H12.47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellectual);
export default __webpack_public_path__ + "static/media/intellectual.b49d6d5caed6e3b6d014d1abc44f50ff.svg";
export { ForwardRef as ReactComponent };